export default __webpack_public_path__ + "static/14-28a3f15d43a02d34da3ae74ce1c4f4f6.png";